import shop from "@/api/products";

// initial state
const state = {
    all: [],
    product: {},
    bestSellers: [],
    availableForBestSeller: []
};

// getters
const getters = {
    product: state => {
        return state.product;
    },
    productCategories: state => {
        return state.all.filter(n=>n.state).map(m => {
            return {
                name: m.sku + " - " + (m.productCategory
                    ? m.productCategory.name + " - " + m.name
                    : m.name),
                id: m.id
            };
        });
    }
};

// actions
const actions = {
    getAllProducts: async context => {
        let d = (await shop.getProducts()).data;
        context.commit("getProducts", d);
    },
    searchProduct: async (context, product) => {
        let d = (await shop.searchProduct(product)).data;
        context.commit("getProducts", d);
        return d;
    },
    getProductsByMpProducts: async context => {
        let d = (await shop.getProductsByMpProducts()).data;
        context.commit("getProductsByMpProducts", d);
    },
    searchProduct: async (context, product) => {
        let d = (await shop.searchProduct(product)).data;
        context.commit("getProducts", d);
        return d;
    },
    getProduct: async (context, id) => {
        let d = (await shop.getProduct(id)).data;
        context.commit("getProduct", d);
        return d;
    },
    postProduct: async (context, product) => {
        const result = (await shop.postProduct(product)).data;
        context.commit("postProduct", result);
    },
    putProduct: async (context, product) => {
        console.log("Store putProduct çağrıldı:", product);
        const result = (await shop.putProduct(product)).data;
        console.log("Store putProduct sonucu:", result);
        context.commit("putProduct", result);
        return result;
    },
    deleteProduct: async (context, product) => {
        (await shop.deleteProduct(product)).data;
        context.commit("deleteProduct", product);
    },
    clearProducts: context => {
        context.commit("clearProducts");
    },
    getBestSellers: async context => {
        let d = (await shop.getBestSellers()).data;
        context.commit("setBestSellers", d);
        return d;
    },
    getAvailableProductsForBestSeller: async (context, q = null) => {
        let d = (await shop.getAvailableProductsForBestSeller(q)).data;
        context.commit("setAvailableForBestSeller", d);
        return d;
    },
    addToBestSellers: async (context, productIds) => {
        await shop.addToBestSellers(productIds);
        await context.dispatch('getBestSellers');
        return true;
    },
    removeFromBestSeller: async (context, productId) => {
        await shop.removeFromBestSeller(productId);
        await context.dispatch('getBestSellers');
        return true;
    },
    updateBestSellerOrder: async (context, productIds) => {
        context.commit("reorderBestSellers", productIds);
        await shop.updateBestSellerOrder(productIds);
        return true;
    },
    clearBestSellers: context => {
        context.commit("clearBestSellers");
    }
};

// mutations
const mutations = {
    getProducts(state, products) {
        state.all = products;
    },
    getProductsByMpProducts(state, products) {
        state.all = products;
    },
    getProduct(state, product) {
        //state.product = product
        state.product = null;
        state.product = Object.assign({}, state.product, product);
    },
    postProduct(state, product) {
        //state.product = product
        state.product = null;
        state.product = Object.assign({}, state.product, product);
    },
    putProduct(state, product) {
        //state.product = product
        state.product = null;
        state.product = Object.assign({}, state.product, product);
    },
    deleteProduct(state, product) {
        state.all.splice(state.all.indexOf(product), 1);
    },
    decrementProductInventory(state, {id}) {
        const product = state.all.find(product => product.id === id);
        product.inventory--;
    },
    clearProducts(state) {
        state.all = [];
    },
    setBestSellers(state, products) {
        state.bestSellers = products;
    },
    setAvailableForBestSeller(state, products) {
        state.availableForBestSeller = products;
    },
    reorderBestSellers(state, productIds) {
        const reordered = [];
        productIds.forEach((id, index) => {
            const item = state.bestSellers.find(p => p.id === id);
            if (item) {
                reordered.push({ ...item, bestSellerOrder: index + 1 });
            }
        });
        state.bestSellers = reordered;
    },
    clearBestSellers(state) {
        state.bestSellers = [];
        state.availableForBestSeller = [];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
